module.exports = __webpack_public_path__ + "img/chart-column.e76ba6cd.svg";